// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35CyJ","footer":"styles_footer__1-SKi"};